/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface EditInvoiceAuditNotesInput
 */
export interface EditInvoiceAuditNotesInput {
  /**
   *
   * @type {string}
   * @memberof EditInvoiceAuditNotesInput
   */
  companyId: string;
  /**
   *
   * @type {string}
   * @memberof EditInvoiceAuditNotesInput
   */
  invoiceAuditNotes: string;
}

/**
 * Check if a given object implements the EditInvoiceAuditNotesInput interface.
 */
export function instanceOfEditInvoiceAuditNotesInput(
  value: object,
): value is EditInvoiceAuditNotesInput {
  if (!("companyId" in value) || value["companyId"] === undefined) return false;
  if (
    !("invoiceAuditNotes" in value) ||
    value["invoiceAuditNotes"] === undefined
  )
    return false;
  return true;
}

export function EditInvoiceAuditNotesInputFromJSON(
  json: any,
): EditInvoiceAuditNotesInput {
  return EditInvoiceAuditNotesInputFromJSONTyped(json, false);
}

export function EditInvoiceAuditNotesInputFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EditInvoiceAuditNotesInput {
  if (json == null) {
    return json;
  }
  return {
    companyId: json["companyId"],
    invoiceAuditNotes: json["invoiceAuditNotes"],
  };
}

export function EditInvoiceAuditNotesInputToJSON(
  json: any,
): EditInvoiceAuditNotesInput {
  return EditInvoiceAuditNotesInputToJSONTyped(json, false);
}

export function EditInvoiceAuditNotesInputToJSONTyped(
  value?: EditInvoiceAuditNotesInput | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    companyId: value["companyId"],
    invoiceAuditNotes: value["invoiceAuditNotes"],
  };
}
